module.exports = __webpack_public_path__ + "media/images/team/divina-sibay-f1ae79f3862523962121c1c250a700e9.png";